<template>
    <div class="reports-tab-nav">

        <div class="row py-2 mb-3">
            <div class="col-sm-4 company-form-box-title">
                Loan/Advance Application List
            </div>

            <template v-if="$acl['templates/list'] > 1">
                <div class="col-sm-8 attendance-button-wrapper">
                    <b-button class="" @click="addNew()" style="max-width: 325px;">Add Loan/Advance Manually</b-button>
                </div>
            </template>
        </div>

        <!-- Abdullah26 added clss  -->
        <common-list class="Loan-application-table" :checkbox="checkbox" :is_action="is_action"
            :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="loans"
            :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list>

        <b-modal id="decline-modal" title="Are you sure you want to decline this Loan?" hide-footer>
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"
                @click="pauseLoan(loan_entity_id)">Decline
                <span v-if="loading != ''"><img :src="this.$api_url + '/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block
                @click="$bvModal.hide('decline-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>

        <b-modal id="delete-modal" title="Are you sure you want to delete this Loan?" hide-footer>
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"
                @click="deleteLoan(loan_entity_id)">Delete
                <span v-if="loading != ''"><img :src="this.$api_url + '/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block
                @click="$bvModal.hide('delete-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>
        <b-modal id="bv-modal-loan" size="lg" hide-footer v-bind:title="modal_title">
            <loan-form :flg="flg" :employee_id="0" :key="count" :count="count" :loan_id="loan_id" :is_custom="is_custom"
                :is_status="is_status" v-on:childToParent="getLoanData"></loan-form>
        </b-modal>
        <b-modal id="bv-modal-loan-new" size="lg" hide-footer v-bind:title="modal_title">
            <loan-form :flg="0" :employee_id="this.em_id" :key="count" :count="count" :loan_id="0" :is_custom="0"
                v-on:childToParent="getLoanData"></loan-form>
        </b-modal>
        <b-modal id="installment-modal" title="Installment Breakdown" hide-footer>
            <!-- <div class="row table-head">
                <div class="col-sm-4 font-weight-bold py-2">
                    Installment No.
                </div>
                <div class="col-sm-4 font-weight-bold py-2">
                    Month
                </div>
                <div class="col-sm-4 font-weight-bold py-2">
                    Amount
                </div>
            </div>
            <div class="row table-row hover-bg" v-for="(row, index) in my_installments" :key="index">
                <div class="col-sm-4 py-2 align-items-center d-flex">
                    <div :style="(row.status == 3) ? styleA : styleB">Installement #{{ index + 1 }}</div>
                </div>
                <div class="col-sm-4 py-2 align-items-center d-flex"
                    v-bind:style="[(row.status == 3) ? { styleA } : { styleB }]">
                    <div :style="(row.status == 3) ? styleA : styleB">{{ formatMoney(row.month) }}</div>
                </div>
                <div class="col-sm-4 py-2 align-items-center d-flex"
                    v-bind:style="[(row.status == 3) ? { styleA } : { styleB }]">
                    <div :style="(row.status == 3) ? styleA : styleB">{{ formatMoney(row.amount) }}</div>
                </div>
            </div>
            <br /> -->

            <div class="table-responsive">
                <table class="table dataTable border">
                    <thead>
                        <tr class="table-head">
                            <th>Installment No.</th>
                            <th>Month</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="hover-bg table-row border-bottom mx-2" v-for="(row, index) in my_installments"
                            :key="index">
                            <td :style="(row.status == 3) ? styleA : styleB">Installement #{{ index + 1 }}</td>
                            <td :style="(row.status == 3) ? styleA : styleB">{{ formatMoney(row.month) }}</td>
                            <!-- alpha fix- added class text-right  -->
                            <td class="text-right" :style="(row.status == 3) ? styleA : styleB">{{ formatMoney(row.amount) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block
                @click="$bvModal.hide('installment-modal')">Close</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>
        <b-modal id="bv-modal-employee" size="lg" hide-footer v-bind:title="modal_title">
            <loan-search-employee v-on:childToParent="setEmployee"></loan-search-employee>
        </b-modal>
        <b-modal id="bv-modal-loan-transactions-wizard" size="lg" hide-footer v-bind:title="modal_title">
            <loan-transaction-wizard :key="tx_popup_count" :loan_id="loan_id"></loan-transaction-wizard>
        </b-modal>

    </div>
</template>


<script>
export default {

    mounted() {

    },
    props: ['flg', 'loan_type'],
    data() {

        return {
            /**Child Component property data */
            is_action: 1,
            checkbox: 0,
            list_key: 0,
            loans: [],
            default_column: ['name', 'employee_code'],
            appended_column: [
                { value: "company_loan_id", text: "Loan ID", type: "text" },
                { value: "loan_type", text: "Type", type: "text" },
                { value: "loan_amount", text: "Amount", type: "number" },
                { value: "effective_date_of_loan", text: " Effective Date", type: "date" },
                { value: "deduction_start_month", text: "Deduction Start Month", type: "monthyear" },
                { value: "loan_tenure", text: "Tenure Month(s)", type: "number" },
                { value: "loan_status", text: "Status", type: "text" },
            ],
            primary_key: 'id',
            company_options: [],
            /***Child Component property data */
            tmp_loans: [],
            loan_id: '',
            styleA: 'color:#55ce63 !important',
            styleB: 'color:#009efb !important',
            my_installments: [],
            is_custom: '',
            is_status: '',
            loan_types_drop: ['', 'Loan', 'Advance'],
            bank_names: [
                { value: null, text: "--Select--" },
            ],
            em_id: 0,
            modal_title: '',
            count: '',
            loan_stat_title: ["Declined", "Applied", "Approved", "Pause/Stopped", "Returned"],
            default_tenure: [0, 150, 0],
            showoverlay_list: false,
            successmsg: '',
            errormsg: [],
            selected: [],
            loading: '',
            showoverlaymodal: false,
            loan_entity_id: '',
            loan_update_status: '',
            tx_popup_count: 0,
            loan_status: [
                { value: null, text: "Select..." },
                { value: "0", text: "Declined" },
                { value: "1", text: "Applied" },
                { value: "2", text: "Approved" },
                { value: "3", text: "Pause/Stopped" },
                { value: "4", text: "Returned" },
            ],

        }
    },
    methods: {
        formatMoney: function (amount) {
            var money = Number(amount);
            money = money.toLocaleString();
            if (money == 'NaN')
                money = amount;
            else {
                if (money.indexOf(".") < 0)
                    money = money + ".00";
            }
            return money;
        },
        toMoney: function (amount) {
            if (amount != "0") {
                if (!isNaN(amount)) {
                    var number = Number(amount);
                    return number;
                }
                var NumWithoutCommas = amount.replace(/,/g, '');
                var number = Number(NumWithoutCommas).toFixed(2);
                return number;
            } else
                return amount;
        },
        addNew: function () {
            this.$bvModal.show('bv-modal-employee');
        },
        listReturn: function (data) {
            if (data.selected.length > 0) {
                this.selected = data.selected;
            }
            else {
                this.selected = [];
                if (data.id > 0) {

                    if (data.action_id == 0) {
                        this.showEmployeeDetails(data.id);
                    }
                    else if (data.action_id == 1) {
                        this.editLoanInfo(data.id, 0, 0);
                    }
                    else if (data.action_id == 2) {
                        this.editLoanInfo(data.id, 1, 0);
                    }
                    else if (data.action_id == 3) {
                        this.showDeclineModal(data.id);
                    }
                    else if (data.action_id == 4) {
                        this.editLoanInfo(data.id, 0, 3);
                    }
                    else if (data.action_id == 5) {
                        this.editLoanInfo(data.id, 0, 2);
                    }
                    else if (data.action_id == 6) {
                        this.showInstallment(data.id);
                    }
                    else if (data.action_id == 7) {
                        this.editLoanInfo(data.id, 0, 1);
                    }
                    else if (data.action_id == 8) {
                        this.showLoanTransactions(data.id);
                    }
                    else if (data.action_id == 9) {
                        this.showDeleteModal(data.id);
                    }
                }

            }
        },
        setEmployee: function (emplyee_id) {
            this.em_id = emplyee_id;
            this.count = this.count + 1;
            this.modal_title = "Add Loan / Advance";
            this.$bvModal.hide('bv-modal-employee');
            this.$bvModal.show('bv-modal-loan-new');
        },
        showEmployeeDetails: function (x) {
            if (!this.checkNet()) return false;
            this.showoverlay = true;
            let currentObj = this;
            let formData = new FormData();
            formData.append('loan_id', x);
            axios.post(this.$api_url + '/loan-advance/setemployee', formData)
                .then(function (response) {
                    this.showoverlay = false;
                    window.location.href = this.$api_url + '/loan-advance/info';

                }.bind(this))
                .catch(function (error) {
                    currentObj.showoverlay = false;
                    currentObj.serverError(error);
                });


        },
        showDeleteModal: function (pageflg) {
            this.loan_entity_id = pageflg;
            this.$bvModal.show('delete-modal');
            this.approvepass = '';
        },

        showDeclineModal: function (pageflg) {
            this.loan_entity_id = pageflg;
            this.loan_update_status = 0;
            this.$bvModal.show('decline-modal');
            this.approvepass = '';
        },
        showLoanTransactions: function (loan_id) {
            this.loan_id = loan_id;
            this.tx_popup_count = this.tx_popup_count + 1;
            this.$bvModal.show('bv-modal-loan-transactions-wizard');

        },
        showInstallment: function (loan) {
            if (!this.checkNet()) return false;
            let currentObj = this;
            let formData = new FormData();
            formData.append('id', loan);
            this.my_installments = [];
            this.showoverlay = true;
            axios.post(this.$api_url + '/loan-advance/installments', formData)
                .then(function (response) {
                    this.my_installments = response.data;
                    this.showoverlay = false;
                    this.$bvModal.show('installment-modal');

                }.bind(this)).catch(function (error) { currentObj.serverError(error); });

        },
        pauseLoan: function (pageflg) {

            this.loading = 'load';
            var update_status = this.loan_update_status;
            let formData = new FormData();
            formData.append('loan_id', pageflg);
            formData.append('status', update_status);
            axios.post(this.$api_url + '/loan-update-status', formData)
                .then(function (response) {
                    this.$bvModal.hide('pause-modal');
                    this.$bvModal.hide('approve-modal');
                    this.$bvModal.hide('decline-modal');
                    this.loan_entity_id = '';
                    this.loan_update_status = '';
                    this.loading = '';
                    this.getLoanData();
                }.bind(this))
                .catch(function (error) {
                    currentObj.showoverlay = false;
                    currentObj.serverError(error);
                });

        },
        deleteLoan: function (pageflg) {

            this.loading = 'load';
            var update_status = this.loan_update_status;
            let formData = new FormData();
            formData.append('loan_id', pageflg);
            axios.post(this.$api_url + '/loan-delete', formData)
                .then(function (response) {
                    this.$bvModal.hide('pause-modal');
                    this.$bvModal.hide('approve-modal');
                    this.$bvModal.hide('decline-modal');
                    this.$bvModal.hide('delete-modal');
                    this.loan_entity_id = '';
                    this.loan_update_status = '';
                    this.loading = '';
                    this.getLoanData();
                }.bind(this))
                .catch(function (error) {
                    currentObj.showoverlay = false;
                    currentObj.serverError(error);
                });

        },
        getLoanData: function () {
            var loan_type = 1;
            this.loan_title = 'Employee Loan/Advance List';
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/loan-advance/applicationlist', {
                params: {
                    loan_type: loan_type
                }
            }).then(function (response) {

                this.tmp_loans = response.data.employee_data;
                this.company_options = response.data.options;

                if (this.tmp_loans.length > 0) {
                    this.tmp_loans.forEach(element => {
                        if (element.id > 0) {

                            element.loan_amount = this.formatMoney(element.loan_amount);
                            let dop = [];

                            // alpha fix- commented this
                            // if (this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Pause/Stopped' || this.loan_stat_title[element.status] == 'Declined') {
                            //     if (this.$acl['templates/list'] > 1)
                            //         dop = dop.concat([{ label: 'Approve', value: 5 }]);
                            // }

                            // if (this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Approved' || this.loan_stat_title[element.status] == 'Pause/Stopped' || this.loan_stat_title[element.status] == 'Declined') {
                            //     if (this.$acl['templates/list'] > 1)
                            //         dop = dop.concat([{ label: 'Edit', value: 1 }]);
                            // }
                            // if (element.has_tx == 0 && element.is_locked == 0 && (this.loan_stat_title[element.status] == 'Approved' || this.loan_stat_title[element.status] == 'Declined')) {
                            //     if (this.$acl['templates/list'] > 1)
                            //         dop = dop.concat([{ label: 'Unapprove', value: 7 }]);
                            // }
                            // if (element.has_tx == 0 && element.is_locked == 0 && (this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Approved')) {
                            //     if (this.$acl['templates/list'] > 1)
                            //         dop = dop.concat([{ label: 'Decline', value: 3 }]);
                            // }
                            // if (element.has_tx == 0 && element.is_locked == 0 && (this.loan_stat_title[element.status] == 'Approved' || this.loan_stat_title[element.status] == 'Declined' || this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Pause/Stopped')) {
                            //     if (this.$acl['templates/list'] > 1)
                            //         dop = dop.concat([{ label: 'Delete', value: 9 }]);
                            // }
                            // if (this.loan_stat_title[element.status] == 'Approved') {
                            //     if (this.$acl['templates/list'] > 1)
                            //         dop = dop.concat([{ label: 'Pause / Stop', value: 4 }]);
                            // }
                            // if (this.loan_stat_title[element.status] == 'Approved') {
                            //     if (this.$acl['templates/list'] > 1)
                            //         dop = dop.concat([{ label: 'Manual Payment', value: 2 }]);
                            // }
                            // if (this.loan_stat_title[element.status] == 'Returned' || this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Approved' || this.loan_stat_title[element.status] == 'Pause/Stopped') {
                            //     dop = dop.concat([{ label: 'Installments', value: 6 }]);
                            // }

                            // dop = dop.concat([{ label: 'Transactions', value: 8 }]);


                            // alpha fix- added this
                            if (this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Pause/Stopped' || this.loan_stat_title[element.status] == 'Declined') {
                                if (this.$acl['templates/list'] > 1)
                                    dop = dop.concat([{ label: 'Approve', value: 5, icon: 'fas fa-check-double' }]);
                            }

                            if (this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Approved' || this.loan_stat_title[element.status] == 'Pause/Stopped' || this.loan_stat_title[element.status] == 'Declined') {
                                if (this.$acl['templates/list'] > 1)
                                    dop = dop.concat([{ label: 'Edit', value: 1, icon: 'fas fa-edit' }]);
                            }
                            if (element.has_tx == 0 && element.is_locked == 0 && (this.loan_stat_title[element.status] == 'Approved' || this.loan_stat_title[element.status] == 'Declined')) {
                                if (this.$acl['templates/list'] > 1)
                                    dop = dop.concat([{ label: 'Unapprove', value: 7, icon: 'fas fa-undo-alt' }]);
                            }
                            if (element.has_tx == 0 && element.is_locked == 0 && (this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Approved')) {
                                if (this.$acl['templates/list'] > 1)
                                    dop = dop.concat([{ label: 'Decline', value: 3, icon: 'fas fa-ban' }]);
                            }
                            if (element.has_tx == 0 && element.is_locked == 0 && (this.loan_stat_title[element.status] == 'Approved' || this.loan_stat_title[element.status] == 'Declined' || this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Pause/Stopped')) {
                                if (this.$acl['templates/list'] > 1)
                                    dop = dop.concat([{ label: 'Delete', value: 9, icon: 'fas fa-trash' }]);
                            }
                            if (this.loan_stat_title[element.status] == 'Approved') {
                                if (this.$acl['templates/list'] > 1)
                                    dop = dop.concat([{ label: 'Pause / Stop', value: 4, icon: 'fas fa-pause' }]);
                            }
                            if (this.loan_stat_title[element.status] == 'Approved') {
                                if (this.$acl['templates/list'] > 1)
                                    dop = dop.concat([{ label: 'Manual Payment', value: 2, icon: 'fas fa-money-bill-alt' }]);
                            }
                            if (this.loan_stat_title[element.status] == 'Returned' || this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Approved' || this.loan_stat_title[element.status] == 'Pause/Stopped') {
                                dop = dop.concat([{ label: 'Installments', value: 6, icon: 'fab fa-delicious' }]);
                            }

                            dop = dop.concat([{ label: 'Transactions', value: 8, icon: 'fas fa-table' }]);

                            element.actions = dop;
                        }
                    });

                }


                this.loans = this.tmp_loans;
                this.list_key = this.list_key + 1;

                this.$bvModal.hide('bv-modal-loan');
                this.$bvModal.hide('bv-modal-loan-new');
            }.bind(this)).catch(function (error) { currentObj.serverError(error); });

        },
        updateTransactions() {
            if (!this.checkNet()) return false;
            let currentObj = this;

            axios.get(this.$api_url + '/loan-advance/updatetransactions', {
                params: {
                    loan_type: 1
                }
            }).then(function (response) {
                this.$bvModal.hide('bv-modal-loan');
                this.$bvModal.hide('bv-modal-loan-new');
                this.getLoanData();

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });

        },
        editLoanInfo(loan_id, is_custom, is_status) {
             // alpha fix- title now reflects which action triggered the modal
    if (is_custom == 1) {
        this.modal_title = "Manual Payment";
    } else if (is_status == 1) {
        this.modal_title = "Unapprove Loan/Advance";
    } else if (is_status == 2) {
        this.modal_title = "Approve Loan/Advance";
    } else if (is_status == 3) {
        this.modal_title = "Pause / Stop Loan/Advance";
    } else {
        this.modal_title = "Edit Loan/Advance";
    }
            this.is_custom = is_custom;
            this.loan_id = loan_id;
            this.is_status = is_status;
            this.count = this.count + 1;
            this.$bvModal.show('bv-modal-loan');
        },
    },
    created: function () {

        this.updateTransactions();
    }
}
</script>
